let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kMPo5")).then(() => parcelRequire('1QYVb'));